import { Button } from '@ordr-as/umami-react/button';
import { memo, useCallback, useState } from 'react';
import type { PaymentMethodDto } from '../../../../../../generated-api';
import PaymentButtonStatus from '../../../../DigitalBill/unsettled/sidebar/payment/OpenBillCheckout/PaymentButtons/PaymentButtonStatus';
import TerminalDiagnosisDialog from './TerminalDiagnosisDialog/TerminalDiagnosisDialog';
import type { TerminalDisplayState } from '../../../../../context/TerminalStore';

interface Props {
  paymentMethod: PaymentMethodDto;
  terminalState: TerminalDisplayState;
  className: string;
  onClick: () => void;
  onTryAnyway: () => void;
  canTryPaymentAnyway: boolean;
}

const IntegratedTerminalPaymentButton = (props: Props) => {
  const { paymentMethod, terminalState, className, onClick, onTryAnyway, canTryPaymentAnyway } = props;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    if (terminalState === 'OFFLINE') {
      setDialogIsOpen(true);
      return;
    }

    onClick();
  }, [terminalState, onClick]);

  return (
    <>
      <Button className={className} kind="primary" onClick={handleClick}>
        <PaymentButtonStatus terminalState={terminalState} />
        <div className="truncate-2">{paymentMethod.label}</div>
      </Button>
      {dialogIsOpen && (
        <TerminalDiagnosisDialog
          terminalName={paymentMethod.label}
          onCloseDialog={() => setDialogIsOpen(false)}
          onTryPayment={onTryAnyway}
          canTryPaymentAnyway={canTryPaymentAnyway}
          pspTerminalId={paymentMethod.id}
        />
      )}
    </>
  );
};

export default memo(IntegratedTerminalPaymentButton);
